import { render, staticRenderFns } from "./NutritionistDashboard.vue?vue&type=template&id=924d3966&scoped=true&"
import script from "./NutritionistDashboard.vue?vue&type=script&lang=js&"
export * from "./NutritionistDashboard.vue?vue&type=script&lang=js&"
import style0 from "./NutritionistDashboard.vue?vue&type=style&index=0&id=924d3966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924d3966",
  null
  
)

export default component.exports